import { render } from "./Inside.vue?vue&type=template&id=12ff1896"
import script from "./Inside.vue?vue&type=script&lang=js"
export * from "./Inside.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__